/* unplugin-vue-components disabled */import script from "./CancellationDatesManager.vue?vue&type=script&setup=true&lang=js"
export * from "./CancellationDatesManager.vue?vue&type=script&setup=true&lang=js"

import "./CancellationDatesManager.vue?vue&type=style&index=0&id=00080ffc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-00080ffc"]])

export default __exports__